module.exports = __webpack_public_path__ + "img/SI.af560a54.png";